<template>
  <div
    :style="{
      margin: isWideScreen ? '10%' : '5%',
      'margin-top': isWideScreen ? '25px' : '0px',
      'text-align': 'left',
    }"
  >
    <h1
      style="
        text-decoration: underline;
        text-decoration-color: rgb(0, 191, 255);
        text-decoration-thickness: 10px;
      "
    >
      Q&A
    </h1>

    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item
        style="padding-bottom: 10px;padding-top: 10px;"
        v-for="item in mainData.list"
        :key="item.id"
        :name="item.id"
      >
        <div class="collapse-title" slot="title">{{ item.title }}</div>
        <div class="collapse-content" v-html="item.content"></div>
        <div v-if="item.id == 1">
          <!-- 讲怎么连接相机的内容  start -->
          <!-- 第一步 -->
          <h1>{{ mainData.step1 }}</h1>
          <div style="display: flex">
            <el-card
              class="adaptercard"
              :style="{ 'margin-right' : (item.id == 1 || item.id == 2) ? '5px' : '' }"
              v-for="item in mainData.adapter"
              :key="item.id"
            >
              <img v-if="item.id == 1" src="../assets/adapter1.png" />
              <img v-if="item.id == 2" src="../assets/adapter2.jpg" />
              <img v-if="item.id == 3" src="../assets/adapter3.jpg" />
              <div class="adaptertitle">{{ item.title }}</div>

            </el-card>
          </div>
          <!-- 第二步 -->
          <h1>{{ mainData.step2 }}</h1>
          <div :style="{ 'display' : isWideScreen ? 'flex' : 'block' }">
            <el-card
              class="adaptercard"
              :style="{ 'margin-right' : (item.id == 1 || item.id == 11 || item.id == 2) ? '5px' : '' ,
              'width': isWideScreen ? '50%' : '96%',  'margin': isWideScreen ? '6px' : '2%'}"

              v-for="item in mainData.screenshot"
              :key="item.id"
            >
              <img v-if="item.id == 1" src="../assets/camscreen1.jpg" />
              <img v-if="item.id == 11" src="../assets/camscreen1en.jpg" />
              <img v-if="item.id == 2" src="../assets/camscreen2.jpg" />
              <img v-if="item.id == 3" src="../assets/camscreen3.jpg" />

              <div class="adaptertitle" :style="{ 'font-weight' : (item.id == 11 || item.id == 1) ? 'bold' : ''}">{{ item.title }}</div>

            </el-card>
          </div>
          <!-- 第三步 -->
          <h1>{{ mainData.step3 }}</h1>
          <el-card
              class="adaptercard specialCard"
              v-for="item in mainData.connectedApp"
              :key="item.id"
            >
              <img style="max-height:320px;" v-if="item.id == 1" src="../assets/connectedapp.jpg" />
              <!-- <img v-if="item.id == 2" src="../assets/camscreen2.jpg" />
              <img v-if="item.id == 3" src="../assets/camscreen3.jpg" /> -->
              <div class="adaptertitle">{{ item.title }}</div>

            </el-card>

            <p style="color: red;">{{ mainData.note }}</p>
          <!-- 讲怎么连接相机的内容  end -->
        </div>
        <!-- <div>
          在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。
        </div> -->
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { Card, Collapse, CollapseItem } from "element-ui";

export default {
  name: "qanda",
  components: {
    ElCard: Card,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
  },
  props: {
    isWideScreen: Boolean,
  },
  data() {
    return {
      activeNames: [1],
    };
  },
  mounted() {
  },
  computed: {
    mainData() {
      return this.$t("helpList");
    },
  },
  methods: {
    handleChange() {},
  },
};
</script>

<style>
.collapse-title {
  flex: 1 0 90%;
  /* flex: 0 1 54%;// 位于中间 */
  order: 1;
  color: rgb(3, 156, 207);
  border: none;
  height: auto;
  line-height: 22px;
  padding-top: 5px;
  padding-bottom: 10px;
  font-size: large;
  font-weight: bold;
}
::v-deep .el-collapse {
  border: none;
}
.collapse-content {
  font-size: medium;
  color: gray;
}
.adaptercard {
  width: 33%;
  /* padding: 2px; */
  text-align: center;
  vertical-align: bottom;
  align-items: baseline;
}
.adaptercard img {
  /* width: 280px; */
  max-width:100%;
  max-height: 180px;
  margin: 0px;
}
.adaptertitle {
  bottom: 0px;
  vertical-align: bottom;
  margin-top: 20px;
}
.specialCard {
  width: 80%;
}
</style>


// WEBPACK FOOTER //
// src/views/qanda.vue